import React, { useEffect } from "react";
import { Card, Button, Input, Row, Col, Form } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { setFormFieldValue } from "../../../helpers/FormHelper";




const Search = ({ dispatch, initialFilters, clearLoading, searchLoading, setLoadingType }) => {
    const [form] = Form.useForm();


    useEffect(() => {
        form.setFieldsValue({
            code: setFormFieldValue(initialFilters?.code),
            name: setFormFieldValue(initialFilters?.name),
            surname: setFormFieldValue(initialFilters?.surname),
            qv_code: setFormFieldValue(initialFilters?.qv_code),
        });
    }, [form, initialFilters]);


    const onSearch = () => {
        setLoadingType('search');
        const { code, name, surname, qv_code } = form.getFieldsValue();
        const requestFilters = {
            code: setFormFieldValue(code),
            name: setFormFieldValue(name),
            surname: setFormFieldValue(surname),
            qv_code: setFormFieldValue(qv_code),
        };
        const action = {
            type: "set_search_filters",
            payload: requestFilters,
        };
        dispatch(action);
    };


    const onClear = () => {
        setLoadingType('clear');
        const action = {
            type: "set_search_filters",
            payload: {},
        };
        dispatch(action);
        form.resetFields();
    };


    const onEnter = (event) => {
        if (event.key === "Enter") {
            onSearch();
        }
    };


    return (
        <Row gutter={24}>
            <Col span={24}>
                <Form
                    form={form}
                    layout="vertical"
                    name="advanced_search"
                    className="ant-advanced-search-form"
                    onKeyDown={onEnter}
                >
                    <Card style={{ borderRadius: "0" }} bodyStyle={{ paddingBottom: "5px" }} className="pb-0">
                        <Row gutter={24} align="bottom">
                            <Col xl={6} lg={6} md={12} sm={24} xs={24}>
                                <Form.Item name="code" label="Kodi:">
                                    <Input
                                        allowClear
                                        prefix={<SearchOutlined />}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={6} lg={6} md={12} sm={24} xs={24}>
                                <Form.Item name="name" label="Emri:">
                                    <Input
                                        allowClear
                                        prefix={<SearchOutlined />}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={6} lg={6} md={12} sm={24} xs={24}>
                                <Form.Item name="surname" label="Mbiemri:">
                                    <Input
                                        allowClear
                                        prefix={<SearchOutlined />}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={6} lg={6} md={12} sm={24} xs={24}>
                                <Form.Item name="qv_code" label="Kodi i QV-së:">
                                    <Input
                                        allowClear
                                        prefix={<SearchOutlined />}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xl={18} lg={18} md={0} sm={0} xs={0} />
                            <Col xl={3} lg={3} md={6} sm={12} xs={12}>
                                <Form.Item>
                                    <Button
                                        block
                                        ghost
                                        type="primary"
                                        loading={searchLoading}
                                        icon={<SearchOutlined />}
                                        onClick={onSearch}
                                    >
                                        Kërko
                                    </Button>
                                </Form.Item>
                            </Col>
                            <Col xl={3} lg={3} md={6} sm={12} xs={12}>
                                <Form.Item>
                                    <Button
                                        block
                                        danger
                                        loading={clearLoading}
                                        icon={<ClearOutlined />}
                                        onClick={onClear}
                                    >
                                        Pastro
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>
                </Form>
            </Col>
        </Row>
    );
};

export default Search;